module.exports = __webpack_public_path__ + "images/emoji/inbox_tray.bee891f8492aa7179f79.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/inbox_tray.png
// module id = 4195
// module chunks = 14